module.exports = __webpack_public_path__ + "static/consultory-a9b32003ce6aa18e68c01b513454d01a.png";